import React from 'react';

import useReactHookFormProps from '../../../hooks/useReactHookFormProps';

export default function useApprovalStatusModal({
  applicant,
  handleClose,
  deniedReasons,
  approveApplicant,
  cancelApplicant,
  checklistApproved,
  applicationComplete,
}) {
  const checklistApprovedAndApplicationComplete =
    checklistApproved && applicationComplete;
  const [submitting, setSubmitting] = React.useState(false);
  const defaultValues = {
    approvalStatus: null,
    cancelationReason: '',
  };
  const reactHookFormProps = useReactHookFormProps({
    shouldUnregister: true,
    defaultValues,
  });
  const disableSubmit =
    !reactHookFormProps.isValid || !reactHookFormProps.isDirty;
  const approvalStatus = reactHookFormProps.watch('approvalStatus');
  const formFields = [
    {
      name: 'approvalStatus',
      variant: 'radioGroup',
      options: [
        {
          value: 'approve',
          label: 'Approve',
          disabled: !checklistApprovedAndApplicationComplete,
        },
        {
          value: 'cancel',
          label: 'Cancel Application',
        },
      ],
      label: 'Approval Status',
      GridProps: {
        xs: 12,
      },
      rules: {
        required: true,
      },
    },
    ...(approvalStatus === 'cancel'
      ? [
          {
            name: 'cancelationReason',
            variant: 'singleSelect',
            options: deniedReasons?.map((reason) => ({
              value: reason.id,
              text: reason.reason,
            })),
            label: 'Reason for Cancelation',
            GridProps: {
              xs: 6,
            },
            rules: {
              required: true,
            },
          },
        ]
      : []),
  ];

  const handleCloseModal = () => {
    reactHookFormProps.reset();
    handleClose();
    setSubmitting(false);
  };

  const handleSave = () => {
    setSubmitting(true);
    const values = reactHookFormProps.getValues();
    if (approvalStatus === 'approve') {
      approveApplicant(applicant.id, applicant.applicationId, handleCloseModal);
    } else {
      cancelApplicant(
        applicant.id,
        applicant.applicationId,
        values.cancelationReason,
        handleCloseModal,
      );
    }
  };
  return {
    reactHookFormProps,
    formFields,
    handleSave,
    saving: submitting,
    handleCloseModal,
    disableSubmit,
  };
}
